/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_FrenchInputs */

const en_speechmatics_target_language_french = /** @type {(inputs: Speechmatics_Target_Language_FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`French`)
};

const fr_speechmatics_target_language_french = /** @type {(inputs: Speechmatics_Target_Language_FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Francais`)
};

const de_speechmatics_target_language_french = /** @type {(inputs: Speechmatics_Target_Language_FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Französisch`)
};

const it_speechmatics_target_language_french = /** @type {(inputs: Speechmatics_Target_Language_FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`francese`)
};

const ru_speechmatics_target_language_french = /** @type {(inputs: Speechmatics_Target_Language_FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Французский`)
};

const es_speechmatics_target_language_french = /** @type {(inputs: Speechmatics_Target_Language_FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Francés`)
};

const zh_cn2_speechmatics_target_language_french = /** @type {(inputs: Speechmatics_Target_Language_FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法语`)
};

const ja_speechmatics_target_language_french = /** @type {(inputs: Speechmatics_Target_Language_FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フランス語`)
};

const hi_speechmatics_target_language_french = /** @type {(inputs: Speechmatics_Target_Language_FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ्रेंच`)
};

const pt_pt2_speechmatics_target_language_french = /** @type {(inputs: Speechmatics_Target_Language_FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Francês`)
};

/**
* | output |
* | --- |
* | "French" |
*
* @param {Speechmatics_Target_Language_FrenchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_french = /** @type {((inputs?: Speechmatics_Target_Language_FrenchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_FrenchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_french(inputs)
	if (locale === "de") return de_speechmatics_target_language_french(inputs)
	if (locale === "it") return it_speechmatics_target_language_french(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_french(inputs)
	if (locale === "es") return es_speechmatics_target_language_french(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_french(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_french(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_french(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_french(inputs)
	return en_speechmatics_target_language_french(inputs)
});